<div class="card" *ngIf="filtrife?.length > 1">
  <div class="card-body">
    <div class="row">
      <div class="col-lg-2" *ngIf="env.TaskAddon['CalendarTypes']">
        <label for="tutti"  class="control-label col-form-label" > Tipo </label>
        <ng-multiselect-dropdown required [settings]="typedropdownSettings" [placeholder]="'Tipo'" id="tipo" [data]="env.TaskAddon['CalendarTypes']"
                                 [(ngModel)]="CalendarType" (ngModelChange)="filtrifechng()">
        </ng-multiselect-dropdown>
      </div>
      <div class="col-lg-2" *ngIf="!env.TaskAddon['CalendarTypes']">
              <label for="tutti" class="control-label col-form-label" > Tipo </label>
              <ng-multiselect-dropdown required [settings]="dropdownSettings" [placeholder]="'Tipo'" id="tipo" [data]="filtrife"
                [(ngModel)]="filtrifeSel" (ngModelChange)="filtrifechng()">
              </ng-multiselect-dropdown>
              </div>
      <div class="col-lg-2" *ngIf="filtrife?.length > 1 && subFilter?.length>0 ">
        <label for="tutti" class="control-label col-form-label"> Stato </label>
        <ng-multiselect-dropdown required [settings]="subdropdownSettings" [data]="subFilter"
                                 [(ngModel)]="subFilterSel" (ngModelChange)="subFiltrifechng()">
        </ng-multiselect-dropdown>
      </div>
      <div class="col-lg-4" *ngIf="filtrifeSel[0].id == 'A'">
        <label for="tutti"  class="control-label col-form-label"> Tipo Attivita </label>
        <ng-multiselect-dropdown [settings]="dropdownSettings" [placeholder]="'Tipo'" id="tipoa" [data]="Tipi"
                                 [(ngModel)]="TipiSelezionati" (ngModelChange)="TipoCambiato()">
        </ng-multiselect-dropdown>
      </div>
      <div class="col-lg-1" *ngIf="permission.hasOperativeRoles(['AZ', 'PM'])">
        <label for="tutti"  class="control-label col-form-label"> Tutti </label>
        <input type="checkbox" [(ngModel)]="filtro.tutti" (ngModelChange)="filtrifechng()" class="form-control" id="tutti" >
      </div>
      <div class="col-lg-4" *ngIf="permission.hasOperativeRoles(['AZ', 'PM'])">
        <label for="tutti"  class="control-label col-form-label"> Persone </label>
        <ng-multiselect-dropdown [settings]="userdropdownSettings" [placeholder]="'Persone'" id="tizi" [data]="Persone"
                                 [(ngModel)]="PersoneSelezionate" (ngModelChange)="Refresh()">
        </ng-multiselect-dropdown>
      </div>
    </div>
  </div>
</div>
<div class="d-md-flex align-items-center bg-white p-2" *ngIf="env.ClientiAddOn.rma && env.RmaAddOn['AddinCalendar'] && env.Modules.Rma ">
  <div class="ml-auto mt-3 mt-md-0">
    <div class="d-flex align-items-center ml-3">
      <button type="button" (click)="AggiungiRma()" class="btn btn-cyan  p-2">
        <i class="fas fa-plus font-14 mr-1 text-white"> </i>
        <span class="ml-1 text-white font-weight-bold">{{'RMA.addTicket' | translate}}</span>
      </button>
    </div>

  </div>
</div>
<app-fullcalendar [events]="events"
                  (onEditClick)="EditButton($event)"
                  (onAddClick)="AggiungiScadenza()"
                  (onDateChanged)="Refresh($event)"
                  (onClick)="EditButton($event)"
                  [Modificabile]="env.Modules.Scadenzario"
></app-fullcalendar>
<div class="card">
  <div class="card-body">
    <div class="row">
      <div class="col-4" *ngFor="let legenda of env.legenda">
        <h4 class="card-title">{{legenda.area | translate}}</h4>
        <div *ngFor="let item of legenda.legenda">
          <span style="height: 10px;width: 10px;background-color: #bbb;border-radius: 50%;display: inline-block;" [ngStyle]="{'background-color': item.color}"></span>
          &nbsp;
          <span class="text-dark">{{item.label | translate}}</span>
          <br>
        </div>
      </div>
    </div>
  </div>
</div>
